import React from "react";
import { Result } from "antd";
import { Button, ButtonLink } from "../../../misc/button/Button";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

function FailureResultPayment({ message, onReturn, onRetry, showButtons = true }) {
  const { state } = useLocation();
  const declaration = state?.message;

  // Message personnalisé ou message par défaut
  const errorMessage = message || "Le paiement a échoué.";

  return (
    <div className="block-right">
      <div className="info-result-payment">
        <Result status="error" title={errorMessage} />
        {showButtons && (
          <div className="button-container">
            {onReturn ? (
              <Button onClick={onReturn} children="Retour" />
            ) : (
              <ButtonLink to="/tableDeclaration" children="Retour" />
            )}
            {onRetry ? (
              <Button onClick={onRetry} children="Réessayer" />
            ) : (
              <ButtonLink
                to="/declaration-certificate-payment"
                children="Réessayer"
                state={{ message: declaration }}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

FailureResultPayment.propTypes = {
  message: PropTypes.string,
  onReturn: PropTypes.func,
  onRetry: PropTypes.func,
  showButtons: PropTypes.bool,
};

export default FailureResultPayment;
